<div id="results" class="quiz-results-main-container">
    <div class="success-card">
        <div class="success-img">
            <img src="./assets/img/success.gif" />
        </div>
        <h2 class="app-c-heading--h3">Thank you!</h2>
        <p>Thought distortion quiz has been submitted successfully</p>
    </div>
    <div class="results-info-section custom-scrollbar">
        <div class="results-info-header-section">
            <div class="results-card correct-card">
                <h2>{{ correctAnswers.length }}</h2>
                <p class="app-c-heading--h5">Correct</p>
            </div>
            <div class="results-card incorrect-card">
                <h2>{{ wrongAnswers.length }}</h2>
                <p class="app-c-heading--h5">Incorrect</p>
            </div>
        </div>
        <div class="results-info-items">
            <div
                class="thinking-styles-items"
                [class.is-open]="expandedAnswers.has(index)"
                *ngFor="let answer of wrongAnswers; let index = index">
                <button
                    type="button"
                    class="thinking-styles-items__summary"
                    [attr.aria-expanded]="expandedAnswers.has(index)"
                    (click)="toggleAnswer(index)">
                    <span
                        class="selection-button"
                        [innerHTML]="answer.questionComment"></span>
                    <span class="thinking-styles-items__toggle" aria-hidden="true">
                        <svg-icon icon="info-icon-rectangle"></svg-icon>
                    </span>
                </button>
                <div
                    class="thinking-styles-items__details"
                    *ngIf="expandedAnswers.has(index)"
                    [innerHTML]="answer.true"></div>
            </div>
        </div>
        <div class="app-c-card__footer">
            <button
                class="app-c-btn app-c-btn--primary app-c-btn--curve"
                (click)="onFinish()"
                (keypress)="onFinish()"
                translate>
                das.close
            </button>
        </div>
    </div>
</div>
